<div>
  <AdminLogin v-if="!loggedIn" @logged-in="login()"> </AdminLogin>
  <div v-else class="admin-list container">
    <h2> Documents </h2>
    <div class="admin-doc">
      <template v-for="document in documents">
        <label>{{document.name}}
        <span class="new" v-if="newFeedbackCounts[document.id]">
        ({{newFeedbackCounts[document.id]}} new)
        </span>
        </label>
        <a class="btn"
           :href="'/admin/' + document.name"
           style="background-color: var(--purple-4)">view feedback</a>
        <a class="btn" :href="'/doc/' + document.name">feedback link</a>
        <button class="btn"
           style="background-color: var(--red-3)"
           @click="delete_doc(document)">delete</button>
      </template>
    </div>

    <h2> Create new document </h2>
    <form @submit.prevent="create">
      <span class="error">{{error}}</span>
      <label for="name"> Name: </label>
      <input ref="name"
             id="name"
             required>

      <label for="content"> HTML content: </label>
      <textarea ref="content"
                id="content"
                required></textarea>

      <button class="btn"> Create </button>
    </form>
  </div>

</div>
